/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { getOutboundShipment } from "../../../../graphql/outbound/custom-queries";

import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import { orange } from "@material-ui/core/colors";

import {
  Edit,
  FormTab,
  TabbedForm,
  Toolbar,
  TopToolbar,
  useEditController,
  useNotify,
} from "react-admin";

import { BackButton } from "../../../../components/common/BackButton";
import { ForceTitle } from "../../../../components/common/ForceTitle";
import { HistoryTab } from "../../../../components/common/HistoryTab";
import { NotesTab } from "../../../../components/common/NotesTab";
import { HelpButton } from "../../../../components/common/HelpButton";
import { getBackPath } from "../../../../utils/utils";
import { logError } from "../../../../utils/appUtils";

import { getInventory } from "../OutboundUtils";
import { DialogSaveButton } from "./DialogSaveButton";
import { DeepDeleteButton } from "./DeepDeleteButton";
import { PickListItemAside } from "./PickListItemAside";
import { PickListEditHelp } from "./PickListHelp";
import { PickLineItemTab } from "./PickLineItemTab";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  icons: {
    color: orange[600],
    alignItems: "center",
  },
}));

const EditActions = (props) => {
  return (
    <TopToolbar>
      <HelpButton>
        <PickListEditHelp {...props} />
      </HelpButton>
      <BackButton {...props} />
    </TopToolbar>
  );
};

const EditToolbar = ({ setAllInventories, setIsLoaded, ...props }) => {
  const classes = useStyles();
  const notify = useNotify();
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { record } = props;

  useEffect(() => {
    if (!isSaving && !isDeleting && record?.inventoryId) {
      getInventory(record.inventoryId, setAllInventories, setIsLoaded, notify);
    }
  }, [isSaving, isDeleting, record]);

  return (
    <Toolbar style={{ justifyContent: "space-between" }}>
      <Backdrop className={classes.backdrop} open={isSaving || isDeleting}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogSaveButton
        {...props}
        isSaving={isSaving}
        setIsSaving={setIsSaving}
        isDeleting={isDeleting}
        setAllInventories={setAllInventories}
        setIsLoaded={setIsLoaded}
      />
      <DeepDeleteButton
        {...props}
        isSaving={isSaving}
        isDeleting={isDeleting}
        setIsDeleting={setIsDeleting}
      />
    </Toolbar>
  );
};

const getOutboundData = async (record, setOutbound, notify) => {
  // outbound.shipmentLineItems.items is required for updateOutboundQuantity
  try {
    debugger;
    const response = await API.graphql(
      graphqlOperation(getOutboundShipment, { id: record.outboundShipmentId }),
    );
    setOutbound(response.data.getOutboundShipment);
  } catch (err) {
    logError("PickListItemEdit:getOutboundData", err, notify);
  }
};

export const PickListItemEdit = (props) => {
  const notify = useNotify();
  const { record } = useEditController(props);
  const [outbound, setOutbound] = useState(props.location?.state?.outbound);
  const [allInventories, setAllInventories] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false); // used in InventorySearchDialog
  const account = outbound?.account;
  const backPath = getBackPath(props);

  useEffect(() => {
    debugger;
    if (record && !outbound) getOutboundData(record, setOutbound, notify);
  }, [record]);

  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Pick List" />}
      mutationMode="pessimistic"
      aside={
        <PickListItemAside {...props} record={record} backPath={backPath} />
      }
      actions={<EditActions {...props} backPath={backPath} />}
    >
      <TabbedForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={
          <EditToolbar
            {...props}
            record={record}
            outbound={outbound}
            backPath={backPath}
            setAllInventories={setAllInventories}
            setIsLoaded={setIsLoaded}
          />
        }
      >
        <FormTab label="Item Setup">
          <PickLineItemTab
            {...props}
            record={record}
            outbound={outbound}
            account={account}
            allInventories={allInventories}
            setAllInventories={setAllInventories}
            isLoaded={isLoaded}
            setIsLoaded={setIsLoaded}
          />
        </FormTab>
        <FormTab label="Notes">
          <NotesTab />
        </FormTab>
        <FormTab label="History">
          <HistoryTab />
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
